<template>
  <div ref="wrapper" :class="['scroll_container', { hide_scroll: hiddeScroll }]">
    <div ref="content" class="mouse-wheel-content"><slot></slot></div>
  </div>
</template>
<script>
  import BScroll from '@better-scroll/core';
  import PullDown from '@better-scroll/pull-down';
  import PullUp from '@better-scroll/pull-up';
  import MouseWheel from '@better-scroll/mouse-wheel';
  BScroll.use(PullDown);
  BScroll.use(PullUp);
  BScroll.use(MouseWheel);
  export default {
    props: {
      /**
       * 1 滚动的时候会派发scroll事件，会截流。
       * 2 滚动的时候实时派发scroll事件，不会截流。
       * 3 除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
       */
      probeType: {
        type: Number,
        default: 3
      },
      /**
       * 点击列表是否派发click事件
       */
      click: {
        type: Boolean,
        default: false
      },
      scrollbar: {
        type: Boolean,
        default: false
      },
      /**
       * 是否开启横向滚动
       */
      scrollX: {
        type: Boolean,
        default: false
      },
      /**
       * 是否派发滚动事件
       */
      onScroll: {
        type: Function,
        default: undefined
      },
      onScrollEnd: {
        type: Function,
        default: undefined
      },
      /**
       * 列表的数据
       */
      data: {
        type: Array,
        default: null
      },
      /**
       * 是否派发滚动到底部的事件，用于上拉加载
       */
      onPullup: {
        type: Function,
        default: undefined
      },
      /**
       * 是否派发顶部下拉的事件，用于下拉刷新
       */
      onPulldown: {
        type: Function,
        default: undefined
      },
      /**
       * 是否派发列表滚动开始的事件
       */
      onBeforeScroll: {
        type: Function,
        default: undefined
      },
      /**
       * 当数据更新后，刷新scroll的延时。
       */
      refreshDelay: {
        type: Number,
        default: 20
      }
    },
    data() {
      return {
        hiddeScroll: true
      };
    },
    mounted() {
      // 保证在DOM渲染完毕后初始化better-scroll
      this._initScroll();
    },
    methods: {
      _initScroll() {
        if (!this.$refs.wrapper) {
          return;
        }
        const options = {
          probeType: this.probeType,
          click: this.click,
          scrollX: this.scrollX,
          disableMouse: true,
          mouseWheel: {
            speed: 20,
            invert: false,
            easeTime: 300
          },
          scrollbar: this.scrollbar, // 设置为true，使滚动条可以交互

          pullUpLoad: {}, // 开启上拉加载
          pullDownRefresh: {
            threshold: 50, // 下拉刷新触发的距离
            stop: 0
          }, // 开启下拉刷新
          preventDefault: true,
          preventDefaultException: {
            className:
              /(^|\s)(copytxt|interact-msg|highlight|msg-content_chat-img|img|exam_msg_bg|url-content-link|chat-info__content)(\s|$)/
          }
        };
        if (this.scrollbar) {
          options.scrollbar = {
            fade: false,
            interactive: true,
            scrollbarTrackClickable: true,
            scrollbarTrackOffsetType: 'clickedPoint' // can use 'step'};
          };
        }
        // better-scroll的初始化
        this.scroll = new BScroll(this.$refs.wrapper, options);
        this.checkOverflow();
        // 是否派发滚动事件
        if (this.onScroll) {
          this.scroll.on('scroll', () => {
            this.onScroll(this.scroll);
            if (this.scroll.y > 0 && !this.lockDown) {
              this.lockDown = true;
              this.onPulldown(() => {
                setTimeout(() => {
                  this.lockDown = false;
                }, 2000);
              });
            }
          });
        }
        this.scroll.on('scrollEnd', () => {
          if (this.scroll.y < 0 || this.scroll.y > this.scroll.maxScrollY) {
            this.onScrollEnd && this.onScrollEnd(this.scroll);
          }

          // if (this.scroll.y == 0 && !this.lockDown) {
          //   this.lockDown = true;
          //   this.onPulldown(() => {
          //     setTimeout(() => {
          //       this.lockDown = false;
          //     }, 1000);
          //   });
          // }
        });

        // 是否派发滚动到底部事件，用于上拉加载
        if (this.onPullup) {
          this.scroll.on('pullingUp', () => {
            // 下拉动作
            this.onPullup(() => {
              setTimeout(() => {
                this.scroll.finishPullUp();
              }, 1000);
            });
          });
        }

        // 是否派发列表滚动开始的事件
        if (this.beforeScroll) {
          this.scroll.on('beforeScrollStart', () => {
            // this.beforeScroll();
          });
        }
      },
      disable() {
        // 代理better-scroll的disable方法
        this.scroll && this.scroll.disable();
      },
      enable() {
        // 代理better-scroll的enable方法
        this.scroll && this.scroll.enable();
      },
      refresh() {
        // 代理better-scroll的refresh方法
        this.scroll && this.scroll.refresh();
        this.checkOverflow();
      },
      checkOverflow() {
        if (!this.scrollbar) {
          return;
        }
        if (this.scroll?.maxScrollY == -1) {
          this.hiddeScroll = true;
        } else {
          this.hiddeScroll = false;
        }
      },
      scrollTo() {
        // 代理better-scroll的scrollTo方法
        this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
      },
      scrollToIndex(index) {
        index > 1 && this.scrollToElement(this.$refs.content.children[index - 1], 0);
      },
      scrollToBottom() {
        // 代理better-scroll的scrollTo方法
        this.scroll && this.scroll.scrollTo.apply(this.scroll, [0, this.scroll.maxScrollY, 100]);
      },
      scrollToElement() {
        // 代理better-scroll的scrollToElement方法
        this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
      }
    },
    destroyed() {},
    watch: {
      // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
      data() {
        this.$nextTick(() => {
          this.refresh();
        });
      }
    }
  };
</script>
<style scoped lang="less">
  .scroll_container {
    height: 100%;
    overflow: hidden;
    &.hide_scroll {
      /deep/ .bscroll-vertical-scrollbar {
        width: 0 !important;
      }
    }
  }
</style>
